var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h5-button"},[_c('button',{class:_vm.brand == 'COTTI' ? 'open-action' : 'open-action-tc',style:(_vm.buttonStyle),on:{"click":_vm.handleH5Download}},[_vm._v(_vm._s(_vm.buttonTxt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }